import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useAdForBrand(brand) {
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!brand) {
      setAd(null);
      setLoading(false);
      return;
    }

    const db = firebase.firestore();
    
    const unsubscribe = db
      .collection('sites')
      .where('type', '==', 'ad')
      .where('status', '==', 'live')
      .where('brand', '==', brand)
      .limit(1)
      .onSnapshot(
        (snapshot) => {
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            setAd({ id: doc.id, ...doc.data() });
          } else {
            setAd(null);
          }
          setLoading(false);
          setError(null);
        },
        (err) => {
          console.error('Error fetching SalonKit ad:', err);
          setError(err.message);
          setLoading(false);
          setAd(null);
        }
      );

    return () => unsubscribe();
  }, [brand]);

  return [ad, loading, error];
}

